<template>
    <v-container fluid fill-height px-0 class="main-container container-fixed d-block">
        <div class="content-block">
            <HeaderMenu title="История уведомлений" class="mx-6 mb-6" back-page/>
            <v-layout class="notifications-list scroll-layout" column v-if="notifications.length > 0">
                <div
                    v-for="(notification, index) in notifications"
                    :key="index"
                    class="notifications-list__row"
                >
                    <div :class="{'notifications-list__unread': !notification.is_read}">
                        <v-badge
                            dot
                            :value="!notification.is_read"
                        >
                            {{ getDateTime(notification.created) }}
                        </v-badge>
                    </div>
                    <div>{{ notification.notification_name }}</div>
                </div>
            </v-layout>
            <div class="d-flex align-center notifications-list__error" v-else>
                <v-flex class="d-block text-center">
                    <div>
                        <v-img :src="require('@/assets/images/error.svg')" class="d-inline-flex mb-8"/>
                        <div class="common-text text-center">
                            Нет уведомлений
                        </div>
                    </div>
                </v-flex>
            </div>
            <ModalWaiting ref="modalWaiting" title="Загрузка уведомлений" noCancel></ModalWaiting>
        </div>
    </v-container>
</template>

<script>
import HeaderMenu from "@/components/core/HeaderMenu";
import ModalWaiting from "@/components/modals/ModalWaiting";
import {eventBus} from "@/main";

export default {
    name: "NotificationsList",
    components: {
        HeaderMenu,
        ModalWaiting,
    },
    data() {
        return {
            notifications: [],
            month: ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"],
            monthUTC: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        };
    },
    created() {
        eventBus.$on("reconnect", this.loadPage);
    },
    beforeDestroy() {
        eventBus.$off("reconnect", this.loadPage);
    },
    mounted() {
        this.loadPage();
    },
    methods: {
        loadPage() {
            if (this.$route.query.master_key) {
                this.$router.push({name: "master", query: this.$route.query});
            } else if (this.$store.state.accessToken) {
                this.getNotifications();
            } else {
                this.$router.push({ name: "empty" });
            }
        },
        getNotifications() {
            this.notifications = [];
            this.$refs.modalWaiting.open();
            this.$http.get('/hotels/guest/notifications/')
                .then((response) => {
                    this.notifications = response.data.notifications;
                })
                .catch((error) => {
                    if (error.response && error.response.data && error.response.data.code == "access_key_expiration_date_has_expired") {
                        this.$router.push({ name: "final", params: { message: error.response.data.message }});
                    }
                })
                .finally(() => {
                    this.$refs.modalWaiting.close();
                });
        },
        getDateTime(date_time) {
            let dateUTC = new Date();
            let offsetDate = new Date(date_time) + dateUTC.getTimezoneOffset() * 60 * 1000;
            let parsedDate = offsetDate.split(" ");
            let dateStr = parsedDate[2] + " " + this.month[this.monthUTC.indexOf(parsedDate[1])] + " " + parsedDate[3];
            let timeStr = parsedDate[4].slice(0, 5);
            return dateStr + ", " + timeStr;
        },
    },
}
</script>

<style lang="scss">
.notifications-list {
    &::-webkit-scrollbar {
        display: none;
    }

    &__row {
        border-bottom: 1px solid rgba(19, 15, 38, 0.04);
        width: 100%;
        display: flex;
        flex-direction: column;
        padding: 6px 24px;

        &:last-child {
            border: none;
        }
    }

    &__unread .v-badge {
        font-weight: 700;

        .v-badge__badge {
            background-color: #FF4141 !important;
        }
    }

    &__error {
        display: flex;
        height: calc(100% - 56px) !important;
    }
}
</style>